<template>
  <div class="col-md-9">
    <div class="row justify-content-center">
      <div class="col-md-12 site-section-heading pt-4 text-center">
        <h2>Prodej</h2>
      </div>
    </div>

    <div class="row mb-5 profile-section-filters">
      <div class="col-auto">
        <label for="col-form-label m-b-0">Status</label>

        <div class="dropdown">
          <button
            type="button"
            class="btn btn-secondary btn-sm dropdown-toggle"
            id="dropdownMenuOffset"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ activeStatus }}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuOffset">
            <template v-for="status in order_statuses">
              <a
                v-if="activeStatus !== status.name"
                href="#"
                class="dropdown-item"
                @click.prevent="selectStatus(status.key)"
              >
                {{ status.name }}
              </a>
            </template>
          </div>
        </div>
      </div>

      <div class="col-5">
        <div class="form-group">
          <label for="col-form-label m-b-0">Kupující</label>

          <select
            name="buyers"
            class="form-control"
            id="select2-buyers"
            multiple="multiple"
          >
            <option v-for="buyer in buyers" :key="buyer.id" :value="buyer.id">
              {{ buyer.fullname }}
            </option>
          </select>
        </div>
      </div>
<!--
      <div class="col-auto">
        <div class="form-group">
          <label for="col-form-label m-b-0">Datum vytvoření</label>

          <input
            type="text"
            name="date"
            class="form-control"
            id="filter-date-range"
          />
        </div>
      </div>
-->
    </div>

    <ProfileOrdersTable :orders="orders" />

    <h5 v-if="orders.length === 0" class="is-empty mt-5">Žádné objednávky</h5>
  </div>
</template>

<script>
import ProfileOrdersTable from './ProfileOrdersTable.vue'

export default {
  components: {
    ProfileOrdersTable
  },
  props: {
    ordersData: {
      type: Array,
      required: true
    },
    buyers: {
      type: Array,
      required: true
    },
    order_statuses: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      orders: this.ordersData.slice(),
      params: {
        buyers: [],
        status: 'new',
        date: null
      },
      paramsKeys: ['buyers', 'status', 'date'],
      statuses: {
        new: 'Nová',
        payment_request: 'Podklady k platbě',
        delivered: 'Předáno',
        canceled: 'Zrušena'
      },
      fetchTimeout: -1
    }
  },
  computed: {
    activeStatus() {
      if (!this.params.status) {
        return 'Nová'
      }

      return this.statuses[this.params.status]
    }
  },
  mounted() {
    $(() => {
      this.params = queryString.parse(location.search, { arrayFormat: 'bracket' })

      // filter buyers
      $('#select2-buyers').select2({
        theme: 'bootstrap',
        language: 'cs',
        placeholder: ''
      })

      $('#select2-buyers').on('change', () => {
        this.fetch({
          buyers: $('#select2-buyers').val()
        })
      })

      if (this.params.buyers) {
        $('#select2-buyers')
          .val(this.params.buyers.filter((buyerId) => this.isBuyerSelected(buyerId)))
          .trigger('change')
      }

      // filter date
      // const date = this.params.date
      // const daterangepickerOptions = {
      //   startDate: date ? date[0] : moment(),
      //   endDate: date ? date[1] : moment(),
      //   locale: {
      //     format: 'D.M.Y',
      //     separator: ' - ',
      //     applyLabel: 'Použít',
      //     cancelLabel: 'Zrušit',
      //     fromLabel: 'Z',
      //     toLabel: 'Do',
      //     customRangeLabel: 'Vlastní',
      //     weekLabel: 'T',
      //     daysOfWeek: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
      //     monthNames: [
      //       'Leden',
      //       'Únor',
      //       'Březen',
      //       'Duben',
      //       'Květen',
      //       'Červen',
      //       'Červenec',
      //       'Srpen',
      //       'Září',
      //       'Říjen',
      //       'Listopad',
      //       'Prosinec'
      //     ],
      //     firstDay: 1
      //   }
      // }
      // $('#filter-date-range').daterangepicker(daterangepickerOptions, (start, end) => {
      //   this.params.date[0] = start.format('D.M.Y')
      //   this.params.date[1] = end.format('D.M.Y')
      //   this.fetch()
      // })

      this.fetch()
    })
  },
  methods: {
    fetch(params = null) {
      if (params) {
        this.params = { ...this.params, ...params }
      }

      clearTimeout(this.fetchTimeout)
      this.fetchTimeout = setTimeout(async () => {
        const query = queryString.stringify(this.params, { arrayFormat: 'bracket' })
        const newUrl = window.location.origin + window.location.pathname + '?' + query
        history.pushState({}, null, newUrl)

        this.orders = await axios
          .get('/api/profil/objednavky', {
            params: this.params
          })
          .then((r) => r.data.user.orders)
      }, 500)
    },
    isBuyerSelected(buyerId) {
      return this.params.buyers && this.params.buyers.indexOf(buyerId) > -1
    },
    isActiveStatus(statusKey) {
      return this.params.status && this.params.status === statusKey
    },
    selectStatus(statusKey) {
      this.$set(this.params, 'status', statusKey)

      this.fetch()
    }
  }
}
</script>
